import axios from 'axios';
import { checkStatus } from '../utils/response';

// 创建axios实例
const apiClient = axios.create({
  baseURL: 'http://localhost:8082',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器
apiClient.interceptors.request.use(
  (config) => {
    // 可以在这里添加token等认证信息
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
apiClient.interceptors.response.use(
  (response) => {
    // 统一处理响应数据
    const data = response.data;
    console.log('API Response:', data);
    
    // 使用公共方法检查status
    checkStatus(data);
    
    return data;
  },
  (error) => {
    // 处理网络错误
    console.error('API Request Failed:', error);
    
    if (error.response) {
      // 服务器返回错误状态码
      console.error('Server Error:', {
        status: error.response.status,
        data: error.response.data,
        headers: error.response.headers
      });
    } else if (error.request) {
      // 请求发出但没有收到响应 - 通常是网络问题或CORS问题
      console.error('Network/CORS Error:', {
        url: error.config?.url,
        method: error.config?.method,
        message: '无法连接到服务器，可能是网络问题或CORS跨域问题'
      });
    } else {
      // 其他错误
      console.error('Request Setup Error:', error.message);
    }
    
    return Promise.reject(error);
  }
);

// API接口定义
export const loginApi = async (credentials) => {
  try {
    console.log('发送登录请求:', credentials);
    const response = await apiClient.post('/web/study/login', credentials);
    console.log('登录响应:', response);
    return response;
  } catch (error) {
    console.error('登录请求失败:', error);
    
    // 根据错误类型提供更具体的错误信息
    if (error.code === 'ERR_NETWORK') {
      throw new Error('网络连接失败，请检查后端服务是否启动');
    } else if (error.code === 'ERR_CORS') {
      throw new Error('跨域请求被阻止，请检查后端CORS配置');
    } else if (error.request && !error.response) {
      throw new Error('无法连接到服务器，请检查网络连接和后端服务状态');
    }
    
    throw error;
  }
};

// 可以添加更多API接口
export const getUserInfo = async () => {
  try {
    const response = await apiClient.get('/web/study/userinfo');
    return response;
  } catch (error) {
    throw error;
  }
};

export default apiClient;